export enum ADVISOR_ESTIMATE {
    OPEN_FOR_ESTIMATE = "เปิดให้ประเมิน",
    NOT_START_YET = 'ยังไม่ถึงช่วงเวลาที่เปิดให้ประเมิน',
    START_FOR_ESTIMATE = 'เปิดให้ประเมิน',
    END_FOR_ESTIMATE = 'สิ้นสุดเวลาที่เปิดให้ประเมิน'
}